import { render, staticRenderFns } from "./Stronghold.vue?vue&type=template&id=0cf16264&lang=pug&"
import script from "./Stronghold.vue?vue&type=script&lang=js&"
export * from "./Stronghold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports